<nz-card>
    
    <div class="template-list">
        <form nz-form [nzLayout]="'vertical'" [formGroup]="form">
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="dbName" placeholder="{{'agentBuilder.databaseName' | translateTA}}">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control>
                    <input nz-input formControlName="description" placeholder="{{'agentBuilder.databaseDescription' | translateTA}}">
                </nz-form-control>
            </nz-form-item>
        </form>
    </div>
</nz-card>